module.exports = __webpack_public_path__ + "media/images/index/area/faeture_tohoku-09331df067e403a2ea4a4cfad9c69b71.png";